import * as React from "react"
import type { SVGProps } from "react"
const SvgTools = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m17.85 20.8-4.42-4.42 2.1-2.1 4.42 4.43q.43.42.43 1.05 0 .62-.43 1.05a1.4 1.4 0 0 1-1.05.42q-.63 0-1.05-.42m-13.8 0a1.4 1.4 0 0 1-.42-1.04q0-.63.42-1.05l5.85-5.85-1.7-1.7a1 1 0 0 1-.7.27 1 1 0 0 1-.7-.27l-.57-.58v2.25q0 .35-.3.48-.3.12-.55-.13l-2.73-2.72q-.25-.25-.12-.55.12-.3.47-.3h2.25l-.55-.55a1 1 0 0 1-.3-.7q0-.4.3-.7L7.55 4.8a3 3 0 0 1 1.08-.73 3.2 3.2 0 0 1 2.1-.07q.45.15.87.45.2.12.21.35a.5.5 0 0 1-.16.4l-1.9 1.9.55.55a1 1 0 0 1 .28.7 1 1 0 0 1-.28.7l1.7 1.7 2.25-2.25a4 4 0 0 1-.16-.58q-.07-.3-.07-.6 0-1.47 1.02-2.49a3.4 3.4 0 0 1 2.86-1q.18.01.35.07.23.07.29.31a.4.4 0 0 1-.11.41L16.8 6.26a.5.5 0 0 0 0 .7l1.1 1.1a.5.5 0 0 0 .7 0l1.63-1.63a.4.4 0 0 1 .4-.12q.25.04.32.3.05.17.06.35l.02.37q0 1.47-1.02 2.49c-1.02 1.02-1.5 1.01-2.48 1.01q-.3 0-.6-.05a2 2 0 0 1-.58-.17L6.15 20.8a1.4 1.4 0 0 1-1.05.42q-.63 0-1.05-.42" />
  </svg>
)
export default SvgTools
